import React, { useContext } from "react";
import * as FaIcons from "react-icons/fa";
import RegistrationContext from "../../../context/registration/registrationContext";
import ProgressButtons from "../ProgressButtons";
import { useEffect } from "react";
import states from "../../../data/states";
import findBrand from "../../findBrand";
import { brandDomains, fetchBrands } from "../../brand";

const R7PreviousSchoolInformation = () => {
  const registrationContext = useContext(RegistrationContext);
  const {
    onFormDataChange,
    pass: { previousSchool1 },
    formData: {
      previousSchool,
      previousSchoolCity,
      previousSchoolState,
      firstName,
    },
  } = registrationContext;

  const handleChange = (e) => {
    const value = e.target.value;
    e.target.value =
      value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
    onFormDataChange(e);
  };

  const previousSchooldetails = previousSchool !== "";

  const previousSchooldetails1 =
    previousSchool !== "" &&
    previousSchoolCity !== "" &&
    previousSchoolState !== "";

  useEffect(() => {
    const handleBeforeUnload = (event) => {
      const message = "Are you sure you want to leave?";
      event.returnValue = message;
    };
    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);

  useEffect(() => {
    const loadBrands = async () => {
      await fetchBrands();
    };

    loadBrands();
  }, []);

  const brand_holston = brandDomains.brand_holston?.name;
  const brand_pbia = brandDomains.brand_pbia?.name;

  //findBrand is used to check whether holston forms or other forms
  if (findBrand( brand_holston) === true || findBrand(brand_pbia) === true ) {
    return (
      <>
        <div className="sub-form">
          <h2 className="">
            {" "}
            Previous School Information <span>(8/11)</span>
            <hr />
          </h2>
          <div className="group">
            <div>
              <div className="item">
                <div className="asterisk-group">
                  <h3>
                    What is {firstName === "" ? "the Student" : firstName}'s
                    Previous School?
                  </h3>
                  <FaIcons.FaAsterisk className="asterisk-icon" />
                </div>
                <input
                  type="text"
                  name="previousSchool"
                  maxLength="50"
                  onChange={(e) => onFormDataChange(e)}
                  value={previousSchool}
                  style={{
                    border: previousSchool1
                      ? "2px solid #ccc;"
                      : previousSchool !== ""
                      ? "2px solid #ccc"
                      : "#d8302f 2px solid",
                  }}
                />
              </div>

              <div className="item">
                <div className="asterisk-group">
                  <h3>
                    What is {firstName === "" ? "the Student" : firstName}'s
                    Previous School City?
                  </h3>
                </div>
                <input
                  type="text"
                  maxLength="50"
                  name="previousSchoolCity"
                  onChange={(e) => onFormDataChange(e)}
                  value={previousSchoolCity}
                />
              </div>
              <div className="item">
                <div className="asterisk-group">
                  <h3>
                    What is {firstName === "" ? "the Student" : firstName}'s
                    Previous School State?
                  </h3>
                </div>
                {/* <input
                  type="text"
                  maxLength="50"
                  name="previousSchoolState"
                  onChange={(e) => onFormDataChange(e)}
                  value={previousSchoolState}
                /> */}
                 <select
                  name="previousSchoolState"
                  value={previousSchoolState}
                  onChange={(e) => onFormDataChange(e)}
                  // style={{
                  //   border: previousSchool1
                  //     ? "2px solid #ccc;"
                  //     : previousSchoolState !== ""
                  //     ? "2px solid #ccc"
                  //     : "#d8302f 2px solid",
                  // }}
                >
                  <option value="">Please Select</option>
                  {states.map((item) => {
                    return (
                      <option value={Object.keys(item)}>
                        {Object.keys(item)}
                      </option>
                    );
                  })}
                </select>
              </div>
            </div>
          </div>
        </div>
        <ProgressButtons
          validation={previousSchooldetails}
          name="previousSchool1"
        />
      </>
    );
  } else {
    return (
      <>
        <div className="sub-form">
          <h2 className="">
            {" "}
            Previous School Information <span>(6/15)</span>
            <hr />
          </h2>
          <div className="group">
            <div>
              <div className="item">
                <div className="asterisk-group">
                  <h3>
                    What is {firstName === "" ? "the Student" : firstName}'s
                    Previous School?
                  </h3>
                  <FaIcons.FaAsterisk className="asterisk-icon" />
                </div>
                <input
                  type="text"
                  maxLength="50"
                  name="previousSchool"
                  onChange={(e) =>  onFormDataChange(e)}
                  value={previousSchool}
                  style={{
                    border: previousSchool1
                      ? "2px solid #ccc;"
                      : previousSchool !== ""
                      ? "2px solid #ccc"
                      : "#d8302f 2px solid",
                  }}
                />
              </div>

              <div className="item">
                <div className="asterisk-group">
                  <h3>
                    What is {firstName === "" ? "the Student" : firstName}'s
                    Previous School City?
                  </h3>
                  <FaIcons.FaAsterisk className="asterisk-icon" />
                </div>
                <input
                  type="text"
                  name="previousSchoolCity"
                  maxLength="50"
                  onChange={(e) =>  onFormDataChange(e)}
                  value={previousSchoolCity}
                  style={{
                    border: previousSchool1
                      ? "2px solid #ccc;"
                      : previousSchoolCity !== ""
                      ? "2px solid #ccc"
                      : "#d8302f 2px solid",
                  }}
                />
              </div>
              <div className="item">
                <div className="asterisk-group">
                  <h3>
                    What is {firstName === "" ? "the Student" : firstName}'s
                    Previous School State?
                  </h3>
                  <FaIcons.FaAsterisk className="asterisk-icon" />
                </div>
                <select
                  name="previousSchoolState"
                  value={previousSchoolState}
                  onChange={(e) => onFormDataChange(e)}
                  style={{
                    border: previousSchool1
                      ? "2px solid #ccc;"
                      : previousSchoolState !== ""
                      ? "2px solid #ccc"
                      : "#d8302f 2px solid",
                  }}
                >
                  <option value="">Please Select</option>
                  {states.map((item) => {
                    return (
                      <option value={Object.keys(item)}>
                        {Object.keys(item)}
                      </option>
                    );
                  })}
                </select>
              </div>
            </div>
          </div>
        </div>
        <ProgressButtons
          validation={previousSchooldetails1}
          name="previousSchool1"
        />
      </>
    );
  }
};

export default R7PreviousSchoolInformation;
